import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

const BigSwitch = styled(Switch)(({ theme }) => ({
  width: 35, // track width
  height: 20, // track height
  padding: 0,
  display: "flex",
  "& .MuiSwitch-switchBase": {
    padding: 1,
    "&.Mui-checked": {
      transform: "translateX(14px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#7CAF73",
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 18, // thumb diameter
    height: 18,
    boxShadow: "none",
  },
  "& .MuiSwitch-track": {
    borderRadius: 32 / 2,
    opacity: 1,
    backgroundColor: "#ccc",
    boxSizing: "border-box",
  },
}));

export default BigSwitch;
